'use strict';

/* global Raphael */

(function (Raphael)
{

    /**
     * Raphael Tooltip extension.
     *
     * Inspired by http://stratha.us/raphael_js_tooltip
     *
     * @param text
     * @returns {Raphael.el}
     */
    Raphael.el.tooltip = function (text)
    {
        this.tooltip = text;
        this.tooltip.ox = 0;
        this.tooltip.oy = 0;
        this.tooltip.hide();
        this.hover
        (
            function()
            {
                this.tooltip.show().toFront();
            },
            function()
            {
                this.tooltip.hide();
                this.unmousemove();
            }
        );
        return this;
    };

}) (Raphael);
